<template>
  <div class="data-migration">
    <introduce />
    <instructions />
    <serverList />
  </div>
</template>

<script>
import instructions from './components/instructions'
import serverList from './components/serverList'
import introduce from './components/introduce'

export default {
  name: 'DataMigration',
  components: {
    instructions,
    serverList,
    introduce
  },

  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.data-migration {
  .data-migration-introduce {
    margin-bottom: var(--base-size-16);
  }

  .data-migration-instructions {
    margin-bottom: var(--base-size-16);
  }
}

</style>
